import { combineReducers } from 'redux';
import configReducer from './configReducer';
import skinReducer from './skinReducer';
import bookingReducer from './bookingReducer';
import settingsReducer from './settingsReducer';
import productsReducer from './productsReducer';
import errorReducer from './errorReducer';

const rootReducer = combineReducers({
  settingsReducer,
  configReducer,
  skinReducer,
  bookingReducer,
  productsReducer,
  errorReducer,

});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof rootReducer;
export default rootReducer;
